var React = require('react');

function ShowMore (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.25 6.25H1.5V2.5M19.5 10C19.5 5.029 15.471 1 10.5 1C6.87 1 3.749 3.154 2.326 6.25M15.75 13.75H19.5V17.5M1.5 10C1.5 14.971 5.529 19 10.5 19C14.13 19 17.251 16.846 18.674 13.75","stroke":"#4A4A4A","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

ShowMore.defaultProps = {"width":"21","height":"20","viewBox":"0 0 21 20","fill":"none"};

module.exports = ShowMore;

ShowMore.default = ShowMore;
